import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatRelativeTime = (date) => {
  if (!date) return '';
  const now = new Date();
  const past = new Date(date);
  const diffMs = now - past;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return formatDate(date);
};

export const calculateTimeRemaining = (deadline) => {
  if (!deadline) return null;
  const now = new Date();
  const target = new Date(deadline);
  const diffMs = target - now;
  
  if (diffMs <= 0) return { expired: true, text: 'EXPIRED' };
  
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  
  if (diffMins < 60) return { expired: false, text: `${diffMins}m`, urgent: diffMins < 15 };
  if (diffHours < 24) return { expired: false, text: `${diffHours}h ${diffMins % 60}m`, urgent: diffHours < 1 };
  return { expired: false, text: `${diffDays}d ${diffHours % 24}h`, urgent: false };
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  // Format +911234567890 to +91 12345 67890
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 12) {
    return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 7)} ${cleaned.slice(7)}`;
  }
  return phone;
};

export const truncate = (str, length = 50) => {
  if (!str || str.length <= length) return str;
  return `${str.slice(0, length)}...`;
};